import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {promoteToolsSection} from '../browse-tools-mru';

const COMPARE_STORAGE_KEY = 'browse_compare_items';

@Injectable({
  providedIn: 'root'
})
export class CompareService {
  private compareItems: any[] = [];

  constructor(private http: HttpClient) {
    this.compareItems = this.readStored();
  }

  setCompareItems(items: any[]) {
    this.compareItems = Array.isArray(items) ? [...items] : [];
    this.writeStored(this.compareItems);
  }

  getCompareItems(): any[] {
    if (!this.compareItems?.length) {
      this.compareItems = this.readStored();
    }
    return this.compareItems;
  }

  /** Keep Compare at the top of Tools after using the compare page. */
  markCompareUsed(): void {
    promoteToolsSection('compare');
  }

  clearCompareItems() {
    this.compareItems = [];
    try {
      sessionStorage.removeItem(COMPARE_STORAGE_KEY);
    } catch {
      // ignore
    }
  }

  getItems(url: string, id: string, id2: string, id3: string) {
    const params = new HttpParams({
      fromObject: {
        id: id,
        id2: id2 || '',
        id3: id3 || ''
      }
    });
    return this.http.get(url, {params: params});
  }

  private readStored(): any[] {
    try {
      const raw = sessionStorage.getItem(COMPARE_STORAGE_KEY);
      if (!raw) {
        return [];
      }
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private writeStored(items: any[]): void {
    try {
      sessionStorage.setItem(COMPARE_STORAGE_KEY, JSON.stringify(items || []));
    } catch {
      // ignore
    }
  }
}
